/**
 * Set current-menu-item class on link that matches current URL.
 */
export function currentMenuItem() {
  const path = window.location.pathname.split('/').filter((el) => el !== '');
  const domain = window.location.origin;
  const firstNav   = document.querySelector('.page-header nav .wp-block-navigation__container');
  const mainMenuLinks = firstNav.querySelectorAll(':scope > li');

  mainMenuLinks?.forEach(menuItem => {
    const href     = menuItem.querySelector('a')?.getAttribute('href');
    const linkPath = href.replace(domain, '').split('/').filter((el) => el !== '');
    if ( linkPath.length >= 1 && path.length >= 1 ) {
      if ( linkPath[0] === path[0] ) {
        menuItem.classList.add('current-menu-item');
      }
    }
  });
}